// 04-enforce.md 4.1 -- función pura extraída de SubPanelTratos.jsx (mismo tratamiento que
// `subPanelLabels.js`). Calcula el % de avance del formulario de negocio a partir de campos
// obligatorios + documentos subidos + la primera unidad de negocio. La escala es cruda
// (`Math.round(filled / 13) * 100`): en la práctica sólo devuelve 0 o 100 -- comportamiento
// preexistente, preservado tal cual.

const REQUIRED_FIELDS = [
  'nombre_negocio', 'direccion', 'giro', 'representante',
  'contacto_1_nombre', 'contacto_1_correo', 'contacto_1_tel',
];

export function getFormProgress(formData, documents) {
  const data = formData || {};
  let filled = 0;
  REQUIRED_FIELDS.forEach(f => { if (data[f]) filled++; });
  if (data.moneda_usd || data.moneda_mxn) filled++;
  if (data.unidades && data.unidades.length > 0) {
    if (data.unidades[0].nombre) filled++;
    if (data.unidades[0].direccion) filled++;
  }
  filled += (documents || []).length;
  return Math.min(100, Math.round(filled / 13) * 100);
}

export const isFormComplete = (formData, documents) => getFormProgress(formData, documents) >= 100;
